export default {
    tagged: '3.0.4-1a1ae94',
    version: '3.0.4',
    revision: '1a1ae94',
};
//# sourceMappingURL=version.js.map